import CardSidePreview from './CardSidePreview';

export default CardSidePreview;
